import React from 'react';

const ProductMaxAmount = ({ showMax }) => (
  <span className={`max-amount ${showMax ? 'visible' : 'hidden'}`}>
    Max antal uppnått
  </span>
);

export default ProductMaxAmount;
